// extracted by mini-css-extract-plugin
export var growableInput = "_6y-0";
export var tagContainer = "_6y-2";
export var textInput = "_6y-1";